import PropTypes from "prop-types";
import React from "react";
import Rail from "web/react/components/rail/rail";
import RelatedRailCard from "./related-rail-card";
import styles from "./related-rail.css";

function RelatedRail({ title, candidates }) {
    return (
        <div className={styles.railWrapper}>
            <Rail title={title} analyticsLabel="designers" className={styles.rail}>
                {candidates.map((candidate) => {
                    return (
                        <div key={candidate.url}>
                            <RelatedRailCard candidate={candidate} />
                        </div>
                    );
                })}
            </Rail>
        </div>
    );
}

RelatedRail.propTypes = {
    title: PropTypes.string,
    candidates: PropTypes.array.isRequired,
};

export default RelatedRail;
